import { render, staticRenderFns } from "./PreactiveAccounts.vue?vue&type=template&id=9c71aa6e&scoped=true&"
import script from "./PreactiveAccounts.vue?vue&type=script&lang=js&"
export * from "./PreactiveAccounts.vue?vue&type=script&lang=js&"
import style0 from "./PreactiveAccounts.vue?vue&type=style&index=0&id=9c71aa6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c71aa6e",
  null
  
)

export default component.exports